import {
  InstagramIcon,
  FacebookIcon,
  YoutubeIcon,
  SpotifyIcon,
  DeezerIcon,
  // SoundCloudIcon,
  // TammKreizIcon,
  //   logoLuskellus,
  //   joPhotoDesktop,
  //   joPhotoMobile,
} from "../assets/Icon/IconSocialNetwork";

export const socialNetworks = [
  {
    id: "0",
    name: "Instagram",
    icon: InstagramIcon,
    url: "https://www.instagram.com/duodurandleludecdaniel/",
  },
  {
    id: "1",
    name: "Facebook",
    icon: FacebookIcon,
    url: "https://www.facebook.com/DuoDurandLeLudecDaniel/",
  },
  {
    id: "2",
    name: "Youtube",
    icon: YoutubeIcon,
    url: "https://www.youtube.com/@DuoDurand-LeLudecDaniel",
  },
  {
    id: "3",
    name: "Spotify",
    icon: SpotifyIcon,
    url: "https://open.spotify.com/intl-fr/album/5CMQAGWp1dhm5AOVDLE18B",
  },
  {
    id: "4",
    name: "Deezer",
    icon: DeezerIcon,
    url: "https://www.deezer.com/fr/album/972836071",
  },
  //   {
  //   id: "5",
  //   name: "SoundCloud",
  //   icon: SoundCloudIcon,
  //   url: "https://soundcloud.com/durandleludec-daniel",
  // },
  // {
  //   id: "6",
  //   name: "Tammkreiz",
  //   icon: TammKreizIcon,
  //   url: "https://www.tamm-kreiz.bzh/personne/23267/",
  // },
];

// export const logo = [
//   {
//     id: "0",
//     name: "Luskellus",
//     icon: logoLuskellus,
//     url: "https://annuaire-entreprises.data.gouv.fr/entreprise/luskellus-935275677",
//   },
// ];

// export const photo = [
//   {
//     id: "0",
//     ico: joPhotoDesktop,
//     alt: "photo jo daniel",
//     link: "#/",
//   },
//   {
//     id: "1",
//     ico: joPhotoMobile,
//     alt: "photo jo daniel",
//     link: "#/",
//   },
// ];
